<template>  
  <div class="mt-1 text-right">
    <button v-if="$store.getters.loginGroups[0]['groupIdx'] != 4" type="button" class="ml-3 btn btn-primary" @click="onModify()">{{$t('저장')}}</button>
    <button v-if="$store.getters.loginGroups[0]['groupIdx'] != 4" type="button" v-show="!isRegist" class="ml-2 btn btn-danger" @click="onRemove()">{{$t('삭제')}}</button>
    <button type="button" class="ml-2 btn btn-info" @click="pointLogModal()">{{$t('계측이력조회')}}</button>
  </div>
</template>

<script>

export default {
  components: {},
  props: ["isRegist"],
  watch: {},
  data() {
    return {
    };
  },
  computed: {
    
  },
  created() {
  },
  methods: {
    // 저장 버튼 
    onModify() {
      this.$emit("update");
    },
    // 삭제 버튼
    onRemove(){
      // 코드 등록내역 초기화
      this.$emit("delete");
    },
    // 초기화 버튼
    pointLogModal(){
      // 선택 된 코드 삭제
      this.$emit("pointLog");
    }
  },
};
</script>
